
import react, { PureComponent } from 'react';

class FormikError extends PureComponent {
    constructor(props) {
        super(props);
    }

    state = {
        errors: null
    }

    render() {
        const { errors } = this.props;

        return (
            <div className="alert alert-error property-error">test</div>
        );
    }
}

export default FormikError;